/**
 * @flow
 * @relayHash e26dba413ba07ba40d5c2a3548513cf7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedShipmentsContainer_shipments$ref = any;
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type ShipmentSortField = "ACTUAL_SHIP_DATE" | "CARRIER_NAME" | "CREATED_AT" | "CUSTOMER" | "ESTIMATED_SHIP_DATE" | "ORDER_NUMBER" | "SHIPMENT_NUMBER" | "STATUS" | "UPDATED_AT";
export type ShipmentStatus = "DELIVERED" | "DRAFT" | "READY" | "SHIPPED";
export type SortDirection = "ASC" | "DESC";
export type ShipmentSort = {|
  field: ShipmentSortField,
  direction: SortDirection,
|};
export type ShipmentsQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?ShipmentSort,
  statuses?: ?$ReadOnlyArray<ShipmentStatus>,
  customerIds?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
  estimatedShipDateStart?: ?any,
  estimatedShipDateEnd?: ?any,
  actualShipDateStart?: ?any,
  actualShipDateEnd?: ?any,
|};
export type ShipmentsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
    +company: {|
      +id: string
    |},
  |},
  +$fragmentRefs: PaginatedShipmentsContainer_shipments$ref,
|};
export type ShipmentsQuery = {|
  variables: ShipmentsQueryVariables,
  response: ShipmentsQueryResponse,
|};
*/


/*
query ShipmentsQuery(
  $search: String
  $sortBy: ShipmentSort
  $statuses: [ShipmentStatus!]
  $customerIds: [ID!]
  $orderIds: [ID!]
  $estimatedShipDateStart: Date
  $estimatedShipDateEnd: Date
  $actualShipDateStart: Date
  $actualShipDateEnd: Date
) {
  ...PaginatedShipmentsContainer_shipments_4fNyaF
  viewer {
    id
    permissions
    company {
      id
    }
  }
}

fragment PaginatedShipmentsContainer_shipments_4fNyaF on Query {
  shipments(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, estimatedShipDateStart: $estimatedShipDateStart, estimatedShipDateEnd: $estimatedShipDateEnd, actualShipDateStart: $actualShipDateStart, actualShipDateEnd: $actualShipDateEnd) {
    edges {
      cursor
      ...ShipmentsTable_shipmentEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ShipmentsTable_shipmentEdges on ShipmentEdge {
  node {
    id
    shipmentNumber
    status
    carrierName
    trackingNumber
    shippingMethod
    estimatedShipDate
    actualShipDate
    estimatedDeliveryDate
    actualDeliveryDate
    notes
    order {
      id
      orderNumber
    }
    customer {
      id
      name
    }
    createdAt
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ShipmentSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[ShipmentStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "estimatedShipDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "estimatedShipDateEnd",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "actualShipDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "actualShipDateEnd",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company",
      "storageKey": null,
      "args": null,
      "concreteType": "Company",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ]
    }
  ]
},
v3 = {
  "kind": "Variable",
  "name": "actualShipDateEnd",
  "variableName": "actualShipDateEnd"
},
v4 = {
  "kind": "Variable",
  "name": "actualShipDateStart",
  "variableName": "actualShipDateStart"
},
v5 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v6 = {
  "kind": "Variable",
  "name": "estimatedShipDateEnd",
  "variableName": "estimatedShipDateEnd"
},
v7 = {
  "kind": "Variable",
  "name": "estimatedShipDateStart",
  "variableName": "estimatedShipDateStart"
},
v8 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v9 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v10 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v11 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v12 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ShipmentsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "PaginatedShipmentsContainer_shipments",
        "args": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShipmentsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shipments",
        "storageKey": null,
        "args": (v12/*: any*/),
        "concreteType": "ShipmentConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ShipmentEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shipmentNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "carrierName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "trackingNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shippingMethod",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "estimatedShipDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actualShipDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "estimatedDeliveryDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actualDeliveryDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "orderNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Customer",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "shipments",
        "args": (v12/*: any*/),
        "handle": "connection",
        "key": "PaginatedShipmentsContainer_shipments",
        "filters": []
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ShipmentsQuery",
    "id": null,
    "text": "query ShipmentsQuery(\n  $search: String\n  $sortBy: ShipmentSort\n  $statuses: [ShipmentStatus!]\n  $customerIds: [ID!]\n  $orderIds: [ID!]\n  $estimatedShipDateStart: Date\n  $estimatedShipDateEnd: Date\n  $actualShipDateStart: Date\n  $actualShipDateEnd: Date\n) {\n  ...PaginatedShipmentsContainer_shipments_4fNyaF\n  viewer {\n    id\n    permissions\n    company {\n      id\n    }\n  }\n}\n\nfragment PaginatedShipmentsContainer_shipments_4fNyaF on Query {\n  shipments(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, estimatedShipDateStart: $estimatedShipDateStart, estimatedShipDateEnd: $estimatedShipDateEnd, actualShipDateStart: $actualShipDateStart, actualShipDateEnd: $actualShipDateEnd) {\n    edges {\n      cursor\n      ...ShipmentsTable_shipmentEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ShipmentsTable_shipmentEdges on ShipmentEdge {\n  node {\n    id\n    shipmentNumber\n    status\n    carrierName\n    trackingNumber\n    shippingMethod\n    estimatedShipDate\n    actualShipDate\n    estimatedDeliveryDate\n    actualDeliveryDate\n    notes\n    order {\n      id\n      orderNumber\n    }\n    customer {\n      id\n      name\n    }\n    createdAt\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1a3ecd719c83d625b6f90ef74dc4682a';
module.exports = node;
